import { setBalloon } from '@/context/borrower';
import { store } from '@/context/store';
import { MAXIMUM_BALLOON_PERCENT } from '@/utils/constants';
import { IParameter } from '@/utils/setParametersFromParams';

export function setInitialLoanBalloonPercentage(
    parameterBalloonPercentage: IParameter
): void {
    const currentBalloonPercentage =
        store.getState().borrowerReducer.loan.balloon;
    const partner = store.getState().displayReducer.partner;
    const maxBalloon = partner?.maxBalloonPercent || MAXIMUM_BALLOON_PERCENT;

    const parsedParameter = Number(parameterBalloonPercentage);
    if (
        !isNaN(parsedParameter) &&
        parsedParameter > 0 &&
        parsedParameter <= maxBalloon
    ) {
        if (currentBalloonPercentage !== parsedParameter) {
            store.dispatch(setBalloon(parsedParameter));
            return;
        }
    }

    // If URL parameter exceeds maximum, set to maximum instead
    if (parsedParameter > maxBalloon) {
        console.warn(
            `Balloon percentage ${parsedParameter}% from URL exceeds maximum ${maxBalloon}%. Setting to 0.`
        );
    }
}
